// @flow
import { PRODUCT_SERVICES } from 'Client/cms/toolkit/constants';
import * as configQueries from 'Views/configQueries';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_PRODUCT_SERVICES } from 'Utils/request/requestDictionary';

export const productServicesResolver = {
  name: PRODUCT_SERVICES,
  resolve: (appContext: AppContext) => {
    const query = `query {
      config {
        ${configQueries.common()}
      }
    }`;

    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_PRODUCT_SERVICES,
      strictErrors: false,
    });
  },
};
